import InfoPersoStep6FormComponent from '../../components/info-perso/InfoPersoStep6FormComponent';


export default function InfoPersoStep6Bloc() {

      return (
        <div className="">
          <div className="">
            {/* <h2 className="card-title bleu">Votre justificatif d'identité&nbsp;:</h2> */}
            <p className="text m-y-sm"></p>
            <InfoPersoStep6FormComponent />
          </div>
          {/* <div className="mt-lg">
            <p className='text fw-medium'><span className='fushia'>(*)</span> Champs obligatoires</p>
          </div> */}
        </div>
      )
}